import React, { Component } from 'react';
import axios from 'axios';

const baseURL = "https://www.roadtonationals.com/api/women/attendancereport";

class AttendanceReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      yearFilter: 2017,
      nTotalTeams: 0,
      nMeets: 0,
      nAttendance: 0,
      nAvg: 0,
      nChangeTotal: 0,
      nChangeAvg: 0,
      leaders: [],
      change: [],
      conferences: []
    };
  }
  componentWillMount() {
    this.getResults({
      "year": this.state.yearFilter
    });
  }
  getResults(config) {
    var url = baseURL + '/' + config.year;
    axios.get(url)
    .then(response => {
      if (!response.data){

      } else {
      //  console.log(response.data);
        this.setState({
          data: response.data,
          nTotalTeams: Number(response.data.div1.teams) + Number(response.data.div2.teams) + Number(response.data.div3.teams),
          nMeets: Number(response.data.div1.meets) + Number(response.data.div2.meets) + Number(response.data.div3.meets),
          nAttendance: Number(response.data.div1.total) + Number(response.data.div2.total) + Number(response.data.div3.total),
          nAvg: Number(response.data.div1.avg) + Number(response.data.div2.avg) + Number(response.data.div3.avg),
          nChangeTotal: (Number(response.data.div1.total) - Number(response.data.div1last.total)) + (Number(response.data.div2.total) - Number(response.data.div2last.total)) + (Number(response.data.div3.total) - Number(response.data.div3last.total)),
          nChangeAvg: (Number(response.data.div1.avg) - Number(response.data.div1last.avg)) + (Number(response.data.div2.avg) - Number(response.data.div2last.avg)) + (Number(response.data.div3.avg) - Number(response.data.div3last.avg)),
          leaders: response.data.leaders,
          change: response.data.change,
          conferences: response.data.conferences
        });
      }
    })
    .catch(function (error) {
      console.log(error);
    });
  }
  getDivTable() {
    if(this.state.data.div1 !== undefined) {
      return <div className="table-scroll">
        <h4>2017 NCAA Women&apos;s Gymnastics Attendance</h4>
        <table className="report-table">
        <tbody>
          <tr className="header-row">
            <th></th>
            <th>Total Teams</th>
            <th>Meets</th>
            <th>2017 Attendance</th>
            <th>Avg</th>
            <th>Change In Total</th>
            <th>Change In Average</th>
          </tr>
          <tr>
            <td className="left-text-align">Div I Home Attendance</td>
            <td>{this.state.data.div1.teams}</td>
            <td>{this.state.data.div1.meets}</td>
            <td>{this.numberWithCommas(this.state.data.div1.total)}</td>
            <td>{this.numberWithCommas(this.state.data.div1.avg)}</td>
            <td>{this.numberWithCommas(Number(this.state.data.div1.total) - Number(this.state.data.div1last.total))}</td>
            <td>{this.numberWithCommas(Number(this.state.data.div1.avg) - Number(this.state.data.div1last.avg))}</td>
          </tr>
          <tr>
            <td className="left-text-align">Div I Neutral Sites</td>
            <td></td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr className="total-row">
            <td className="left-text-align">NCAA DIVISION I TOTALS</td>
            <td>{this.state.data.div1.teams}</td>
            <td>{this.state.data.div1.meets}</td>
            <td>{this.numberWithCommas(this.state.data.div1.total)}</td>
            <td>{this.numberWithCommas(this.state.data.div1.avg)}</td>
            <td>{this.numberWithCommas(Number(this.state.data.div1.total) - Number(this.state.data.div1last.total))}</td>
            <td>{this.numberWithCommas(Number(this.state.data.div1.avg) - Number(this.state.data.div1last.avg))}</td>
          </tr>
          <tr>
            <td className="left-text-align">Div II Home Attendance</td>
            <td>{this.state.data.div2.teams}</td>
            <td>{this.state.data.div2.meets}</td>
            <td>{this.numberWithCommas(this.state.data.div2.total)}</td>
            <td>{this.numberWithCommas(this.state.data.div2.avg)}</td>
            <td>{this.numberWithCommas(Number(this.state.data.div2.total) - Number(this.state.data.div2last.total))}</td>
            <td>{this.numberWithCommas(Number(this.state.data.div2.avg) - Number(this.state.data.div2last.avg))}</td>
          </tr>
          <tr>
            <td className="left-text-align">Div II Neutral Sites</td>
            <td></td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr className="total-row">
            <td className="left-text-align">NCAA DIVISION II TOTALS</td>
            <td>{this.state.data.div2.teams}</td>
            <td>{this.state.data.div2.meets}</td>
            <td>{this.numberWithCommas(this.state.data.div2.total)}</td>
            <td>{this.numberWithCommas(this.state.data.div2.avg)}</td>
            <td>{this.numberWithCommas(Number(this.state.data.div2.total) - Number(this.state.data.div2last.total))}</td>
            <td>{this.numberWithCommas(Number(this.state.data.div2.avg) - Number(this.state.data.div2last.avg))}</td>
          </tr>
          <tr>
            <td className="left-text-align">Div III Home Attendance</td>
            <td>{this.state.data.div3.teams}</td>
            <td>{this.state.data.div3.meets}</td>
            <td>{this.numberWithCommas(this.state.data.div3.total)}</td>
            <td>{this.numberWithCommas(this.state.data.div3.avg)}</td>
            <td>{this.numberWithCommas(Number(this.state.data.div3.total) - Number(this.state.data.div3last.total))}</td>
            <td>{this.numberWithCommas(Number(this.state.data.div3.avg) - Number(this.state.data.div3last.avg))}</td>
          </tr>
          <tr>
            <td className="left-text-align">Div III Neutral Sites</td>
            <td></td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr className="total-row">
            <td className="left-text-align">NCAA DIVISION III TOTALS</td>
            <td>{this.state.data.div3.teams}</td>
            <td>{this.state.data.div3.meets}</td>
            <td>{this.numberWithCommas(this.state.data.div3.total)}</td>
            <td>{this.numberWithCommas(this.state.data.div3.avg)}</td>
            <td>{this.numberWithCommas(Number(this.state.data.div3.total) - Number(this.state.data.div3last.total))}</td>
            <td>{this.numberWithCommas(Number(this.state.data.div3.avg) - Number(this.state.data.div3last.avg))}</td>
          </tr>
          <tr className="total-row">
            <td className="left-text-align">NATIONAL TOTALS FOR 2017</td>
            <td>{this.state.nTotalTeams}</td>
            <td>{this.state.nMeets}</td>
            <td>{this.numberWithCommas(this.state.nAttendance)}</td>
            <td>{this.numberWithCommas(this.state.nAvg)}</td>
            <td>{this.numberWithCommas(this.state.nChangeTotal)}</td>
            <td>{this.state.nChangeAvg}</td>
          </tr>
        </tbody>
      </table></div>;
    }
  }
  getLeadersTable() {
    if(this.state.data.div1 !== undefined) {
      const leaders = this.state.leaders.map((leader, index) =>
        <tr key={leader.team_id}><td>{index+1}</td><td><a href={'/results/teams/dashboard/'+this.state.yearFilter+'/'+leader.team_id}>{leader.team_name}</a></td><td>{leader.count}</td><td>{this.numberWithCommas(leader.total)}</td><td><strong>{this.numberWithCommas(leader.avg)}</strong></td></tr>
      );
      return <div className="table-scroll">
                <h4>2017 NCAA Women&apos;s Gymnastics Home Attendance Leaders</h4>
                <table className="leader-table"><tbody><tr className="header-row"><th>Rank</th><th>Team</th><th>Meets</th><th>Attendance</th><th>Average</th></tr>{leaders}</tbody></table>
            </div>;
    }
  }
  getChangeTable() {
    if(this.state.data.div1 !== undefined) {
      const leaders = this.state.change.map((team, index) =>
        <tr key={team.team_id}><td>{index+1}</td><td><a href={'/results/teams/dashboard/'+this.state.yearFilter+'/'+team.team_id}>{team.team_name}</a></td><td>{team.count}</td><td>{this.numberWithCommas(team[this.state.yearFilter])}</td><td>{this.numberWithCommas(team[this.state.yearFilter-1])}</td><td><strong>{this.numberWithCommas(team[this.state.yearFilter] - team[this.state.yearFilter-1])}</strong></td></tr>
      );
      return <div className="table-scroll">
                <h4>Largest Home Attendance Increase from Previous Year</h4>
                <table className="leader-table"><tbody><tr className="header-row"><th>Rank</th><th>Team</th><th>Meets</th><th>{this.state.yearFilter} Avg</th><th>{this.state.yearFilter-1} Avg</th><th>Change in Avg</th></tr>{leaders}</tbody></table>
              </div>;
    }
  }
  getConferenceTable() {
    if(this.state.data.div1 !== undefined) {
      const leaders = this.state.conferences.map((conference, index) =>
        <tr key={index}><td>{index+1}</td><td>{conference.name}</td><td>{conference.teams}</td><td>{conference.meets}</td><td><strong>{this.numberWithCommas(conference.total)}</strong></td><td><strong>{this.numberWithCommas(conference.avg)}</strong></td></tr>
      );
      return <div className="table-scroll">
                <h4>2017 NCAA Women&apos;s Gymnastics Attendance by Conference</h4>
                <table className="leader-table"><tbody><tr className="header-row"><th>Rank</th><th>Conference</th><th>Teams</th><th>Meets</th><th>Attendance</th><th>Average</th></tr>{leaders}</tbody></table>
            </div>;
    }
  }
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  render() {
    return (
      <div className="mainContainer">
        <div className="row">
          <div className="small-12 columns">
            {this.getDivTable()}
            <br />
          </div>
        </div>
        <div className="row">
          <div className="small-12 columns">
            {this.getLeadersTable()}
            <br />
          </div>
        </div>
        <div className="row">
          <div className="small-12 columns">
            {this.getChangeTable()}
            <br />
          </div>
        </div>
        <div className="row">
          <div className="small-12 columns">
              {this.getConferenceTable()}
              <br /><br />
          </div>
        </div>
      </div>
    );
  }
}

export default AttendanceReport;



// WEBPACK FOOTER //
// ./src/components/attendance/AttendanceReport.js